import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "../Container";
export function PaperPlane() {
    return (_jsx(Container, { children: _jsx("path", { d: "M17.13,2.4829,6.203,8.7414ZM.4,4.6552l17.2-2.431L6.8827,15.7758,6.2553,9.931,6.203,8.8448l-.1045-.0517V8.69l-.9411-.569Z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.8" }, void 0) }, void 0));
}
//# sourceMappingURL=PaperPlane.js.map